import { useApp } from "../../context";
import { Sheet } from "../../ui/components";
import { BotsView } from "../bots/BotsView";
import { SettingsView } from "../settings/SettingsView";
import { SkillsView } from "../skills/SkillsView";

/** 侧边栏里的功能模块（以弹出页打开）：技能/连接、机器人、设置 */
export function FeatureSheets() {
  const app = useApp();
  const close = () => app.present(undefined);
  return (
    <>
      <SkillsView open={app.presentedFeature === "skills"} onClose={close} />
      <BotsView open={app.presentedFeature === "bots"} onClose={close} />
      <SettingsView open={app.presentedFeature === "settings"} onClose={close} />
    </>
  );
}

export { Sheet };
